








import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

@Component
export default class RenderCargaBarcode extends Vue {
  @Prop({required: true, default: () => []}) items!: string[]

  openModal() {
    this.$modal.open('barcodeDisplay', this.items)
  }
}
